








































import Vue from 'vue';
export default Vue.extend({
  props: {
    recibosInit: Array,
    disabled: Boolean,
  },
  data: () => ({
    openDialog: false,
    persistentes: [],
    headers: [
    { text: 'Propietario', value: 'propietario.nombre'},
    { text: 'Unidad', value: 'unidad.name'},
    { text: 'Conceptos', value: 'items.length'},
    { text: 'Subtotal', value: 'subtotal'},
    { text: 'Monto Total', value: 'total', sortable: false},
    ],
    total: '',
  }),
  methods: {
    async EliminarPersistentes() {
      const admin = this.$store.getters.getAdmin;
      const condo = this.$store.getters.getCondo;
      for (const persistente of this.persistentes) {
        try {
          const recibo = persistente;
          const datos = {admin, condo, recibo};
          console.log('DeleteBorrador %o', datos);
          const response = await this.$store.dispatch('deletePersistente', {admin, condo, recibo});
          console.log('DeleteResponse %o', response);
        } catch (e) {
          console.error(e);
          this.$toast.error(e.response.data.message);
          return;
        }
      }
      if (this.persistentes.length === 1) {
        this.$toast.success('Recibo Persistente eliminado exitosamente');
      } else {
        this.$toast.success('Recibos Persistentes eliminados exitosamente');
      }
      this.openDialog = false;
      this.$emit('reload', {});
    },
  },
  watch: {
    openDialog() {
      if (this.openDialog) {
        this.persistentes = this.recibosInit;
        this.total = this.persistentes.length;
      } else {
        this.persistentes = [];
      }
    },
  },
});
